import { render, staticRenderFns } from "./heroAddFileGallery.vue?vue&type=template&id=fa386636"
import script from "./heroAddFileGallery.vue?vue&type=script&lang=js"
export * from "./heroAddFileGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports